
//$(document).ready(function(){
(function(){
   
/* Load Script function we may need to load jQuery from the Google's CDN */
/* That code is world-reknown. */
/* One source: http://snipplr.com/view/18756/loadscript/ */

var loadScript = function(url, callback){
 
  var script = document.createElement("script");
  script.type = "text/javascript";

  // If the browser is Internet Explorer.
  if (script.readyState){ 
    script.onreadystatechange = function(){
      if (script.readyState == "loaded" || script.readyState == "complete"){
        script.onreadystatechange = null;
        callback();
      }
  };
  // For any other browser.
  } else {
    script.onload = function(){
      callback();
    };
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
    
};

/* This is my app's JavaScript */
var myAppJavaScript = function($){
  // $ in this scope references the jQuery object we'll use.
  // Don't use jQuery, or jQuery191, use the dollar sign.
  // Do this and do that, using $.
  //$('body').append('<p>Your app is using jQuery version '+$.fn.jquery+'</p>');
    $(window).on("load", function(){

		//console.log('acdc loaded');

		/* Minicart gift message click event */
		var giftCheck = $('#allow_gift_options');

		$('#CartDrawer #allow_gift_options, #CartPageForm #allow_gift_options').on('click', function(){
		  $(this).toggleClass('active');
		  $(this).closest('#CartPageForm').find('#allow-gift-options-container').toggleClass('active');
      $(this).closest('#CartDrawer').find('#allow-gift-options-container').toggleClass('active');
		})

    /* Hide engraving option for variants of more than 1 bottle */

    if ( $('.modal--quick-shop.modal--is-active').length ){
      var selectedVariant = $('.modal--quick-shop .variant-wrapper input:checked')
    } else if ( $('.template-product .variant-wrapper input:checked') ) {
      var selectedVariant = $('.template-product .variant-wrapper input:checked')
    } else {
      return
    }
    var selectedOptionText = selectedVariant.val();
    var engravingBox = $('.product__options-wrap');

    //console.log(selectedOptionText)
    if ( selectedVariant.length ){
      if ( selectedOptionText.indexOf("1 Bottle") >= 0 ){
        //console.log( selectedOptionText )
      } else {
        engravingBox.addClass('hide');
        //console.log('hide: ' + selectedOptionText )
      }
    }
    // variant switcher fix for product page 
    $('.template-product .variant-wrapper input').on('click', function(){
      
      if ( $('.modal--quick-shop.modal--is-active').length ){
        var selectedVariant = $('.modal--quick-shop .variant-wrapper input:checked')
      } else {
        var selectedVariant = $('.template-product .variant-wrapper input:checked')
      }
      var selectedOptionText = selectedVariant.val();
      var engravingBox = $('.product__options-wrap');

      if ( selectedOptionText.indexOf("1 Bottle") >= 0 ){
        //console.log( selectedOptionText )
        engravingBox.removeClass('hide');
      } else {
        //console.log('hide: ' + selectedOptionText )
        //uncheck checkbox
        $('#useEngraving').prop('checked', false)
        engravingBox.addClass('hide');
      }
      var variantId = $(this).attr('data-variant-id')
      var variantPrice = $(this).attr('data-variant-price');
      var variantAvailable = $(this).attr('data-available');
      //console.log(variantId)

      /* update browser url */
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variantId;
      window.history.replaceState({path: newurl}, '', newurl);

      /* select select option */
      $('select option[value="' + variantId + '"').attr('selected', 'selected');
      //page-content--product 
      $('select option').each(function(index, elem){
        console.log( $(elem).val() )
        if ( ! ($(elem).val() == variantId) ){
          $(this).removeAttr('selected')
        } 
      })
      setTimeout(function(){
        if ( variantAvailable == 'true'){
          $('.product__price').text(variantPrice);
          $('.add-to-cart').prop('disabled', false);
          $('.add-to-cart').text('ADD TO CART')
          $('.add-to-cart').removeClass('disabled');
        }
      }, 100)


    })
    // variant switcher fix for quickshop modal 
    $('body').on('click', function(){
      console.log('variant clicked')
      //console.log( $(this) );
      if ( $('.modal--quick-shop.modal--is-active').length ){
        var selectedVariant = $('.modal--quick-shop .variant-wrapper input:checked')

        // get value of selected variant
        if ( selectedVariant.length ){
          var selectedOptionText = selectedVariant.val();
          var engravingBox = $('.product__options-wrap');
          if ( selectedOptionText.indexOf("1 Bottle") >= 0 ){
            console.log( selectedOptionText )
            engravingBox.removeClass('hide');
          } else {
            console.log('hide: ' + selectedOptionText )
            //uncheck checkbox
            $('#useEngraving').prop('checked', false)
            engravingBox.addClass('hide');
          }
        }


        var engravingBox = $('.product__options-wrap');

        if ( selectedOptionText.indexOf("1 Bottle") >= 0 ){
          //console.log( selectedOptionText )
          engravingBox.removeClass('hide');
        } else {
          //console.log('hide: ' + selectedOptionText )
          //uncheck checkbox
          $('#useEngraving').prop('checked', false)
          engravingBox.addClass('hide');
        }
        var variantId = selectedVariant.attr('data-variant-id')
        var variantPrice = selectedVariant.attr('data-variant-price');
        var variantAvailable = selectedVariant.attr('data-available');
        

        /* select select option */
        $('.modal--quick-shop.modal--is-active select option[value="' + variantId + '"').attr('selected', 'selected');
        //page-content--product 
        $('.modal--quick-shop.modal--is-active select option').each(function(index, elem){
          console.log( $(elem).val() )
          if ( ! ($(elem).val() == variantId) ){
            $(this).removeAttr('selected')
          } 
        })
        setTimeout(function(){
          if ( variantAvailable === 'true'){
            $('.modal--quick-shop.modal--is-active .product__price').text(variantPrice);
            $('.modal--quick-shop.modal--is-active .add-to-cart').prop('disabled', false);
            $('.modal--quick-shop.modal--is-active .add-to-cart').text('ADD TO CART')
            $('.modal--quick-shop.modal--is-active .add-to-cart').removeClass('disabled');
          }
        }, 100)
      }
    })
    

    /* End Hide engraving option */

    /* Cart Drawer -- if has engraving, show "Remove" option */
    $('#CartDrawer .cart__item').each(function(index, elem){
      if ( $(elem).find('.engraving-lines').length ){
        $(elem).addClass('engraved-item');
        console.log('engraved item');
      }
    })
    /* Engraving related */
    $('#overlay-trigger-confirm').on('click', function(event){
      event.preventDefault();
      if ( $(this).parents('#productOptionsOverlay').length ) {
        //console.log('button clicked is from overlay')
        //console.log(this);
        /* Hide engraving inputs*/
        $('#engravingStart .product__engraving-header').addClass('hide');
        $('#engravingStart .product__engraving-inputs').addClass('hide');
        $('#engravingStart').removeClass('m-t-40');
        $('#overlay-trigger-confirm').addClass('hide');

        /* Show confirmation box */
        $('#productEngraving #engravingEdit').addClass('active');
        $('#productEngraving #engravingEdit').css('display', 'block');
        $('#engravingEdit .product__engraving-header').removeClass('hide');
        
        // get the engraving lines and append content to confirmation box
        $('#productOptionsOverlay .engraving-text').each(function(index){
          var textToAppend = $(this).val().toUpperCase();
          $('#productOptionsOverlay #engravingContent').append('<p class="confirm-label">Line ' + (index + 1) + ':</p>' + '<p>' + textToAppend + '</p>')
        })   
        
      } else {

        // IF engraving is active, AND the submit button wasnt from the overlay, do nothing
        return false;
      }
    })

    /* Engraving overlay -- confirm submit button clicked */
    $('#engravingVerify').on('click', function(event){
      event.preventDefault();
      
      var engravingLine1 = $("#engraving_line_1").val().toUpperCase();
      var engravingLine2 = $("#engraving_line_2").val().toUpperCase();
      var engravingLine3 = $("#engraving_line_3").val().toUpperCase();
      
      function randomString(length, chars) {
          var mask = '';
          if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz';
          if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
          if (chars.indexOf('#') > -1) mask += '0123456789';
          
          var result = '';
          for (var i = length; i > 0; --i) result += mask[Math.floor(Math.random() * mask.length)];
          return result;
      }
      var addOnMatchId = randomString(24, '#aA')

      var $engravingProductForm = $('.engraving-form');
      $engravingProductForm.append(`<input type="hidden" id="referenceProduct" name="properties[_addOnMatchId]" value="${addOnMatchId}">`);
      var data = {
        items: [
          {
            quantity: 1,
            id: 41915688714427, // Variant ID of the Product Being Engraved
            properties: {
              '_addOnMatchId': addOnMatchId
            }
          }  
        ]
      }
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "JSON"
      })
      .done(function(data) {
        //console.log('Engraving product success');
        //console.log( data );
        var dataProduct = $('.engraving-form').serialize();
        //$('.grid__item form').submit();
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: dataProduct,
          dataType: "JSON"
        })
        .done(function(data2){
          //console.log('Main product success')
          //console.log(data2)
          $('#productOptionsOverlay').removeClass('active');
          $('.modal-bg').removeClass('active');
          var cart = new theme.CartDrawer;
          cart.init();
          cart.open();

        })
      })
      .fail(function() {
        //console.log('fail:');
        //console.log( data )
      })
      //$('.engraving-form').submit();
    })
    /* Engraving confirmation ATC click */
    /*$('.engraving-confirm').on('click', function(){
      $('#engravingStart form').submit();
    })*/

    /* if modal overlay background is clicked, close modal */
    $('.modal-bg').on('click', function(){
      $('.modal-bg').removeClass('active');
      $('.product__engraving-content-inner.active').removeClass('active');
      $('#productOptionsOverlay').removeClass('active').css('display', 'none');
      $('#engravingContent').html(''); 
    })

    /* close engraving overlay on clicking the modal 'X' button */
    $('#closeEngraving').on('click', function(){
      $('.modal-bg').removeClass('active')
      $('#productOptionsOverlay').removeClass('active');
      $('#productOptionsOverlay').css('display', 'none');
    })
    
    /* close engraving confirmation box on clicking 'Edit' link */
    $('#engravingEditBtn').on('click', function(){
      $('#engravingEdit').removeClass('active');
      $('#engravingEdit').css('display', 'none');
      $('#engravingStart .product__engraving-header').removeClass('hide');
      $('#engravingStart .product__engraving-inputs').removeClass('hide');
      $('#overlay-trigger-confirm').removeClass('hide');
      $('#engravingContent').html('');
      $('#productOptionsOverlay #engraving_line_1').focus();
    })

	} )
};

/* If jQuery has not yet been loaded or if it has but it's too old for our needs,
we will load jQuery from the Google CDN, and when it's fully loaded, we will run
our app's JavaScript. Set your own limits here, the sample's code below uses 1.7
as the minimum version we are ready to use, and if the jQuery is older, we load 1.9. */
if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.12)) {
  loadScript('//code.jquery.com/jquery-3.6.0.min.js', function(){
    jQuery191 = jQuery.noConflict(true);
    myAppJavaScript(jQuery191);
  });
} else {
  myAppJavaScript(jQuery);
}

})();
